module.exports = __webpack_public_path__ + "img/section1.11ebcbcb.png";